<template>
  <div class="signup-manage">
    <header class="page-header">
      <h2 class="page-header__title">报名管理</h2>
    </header>

    <!-- 搜索区域 -->
    <el-form :inline="true" :model="queryForm" class="search-form">
      <el-form-item label="用户ID">
        <el-input
          v-model="queryForm.userId"
          placeholder="精确搜索"
          clearable
          @keyup.enter.native="handleQuery"
        ></el-input>
      </el-form-item>
      <el-form-item label="赛事ID">
        <el-input
          v-model="queryForm.competitionId"
          placeholder="精确搜索"
          clearable
          @keyup.enter.native="handleQuery"
        ></el-input>
      </el-form-item>
      <el-form-item label="昵称">
        <el-input
          v-model="queryForm.nickname"
          placeholder="模糊搜索"
          clearable
          @keyup.enter.native="handleQuery"
        ></el-input>
      </el-form-item>
      <el-form-item label="赛事名称">
        <el-input
          v-model="queryForm.matchName"
          placeholder="名称模糊搜索"
          clearable
          @keyup.enter.native="handleQuery"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="activeTab === 'prize'" label="奖品名称">
        <el-input
          v-model="queryForm.prizeName"
          placeholder="请输入奖品名称"
          clearable
          @keyup.enter.native="handleQuery"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="activeTab === 'prize'" label="物流状态">
        <el-select
          v-model="queryForm.logisticsStatus"
          placeholder="请选择物流状态"
          clearable
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="未发货" :value="0"></el-option>
          <el-option label="已发货" :value="1"></el-option>
          <el-option label="已签收" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="resetQuery">重置</el-button>
        <el-button type="primary" @click="handleQuery">查询</el-button>
      </el-form-item>
    </el-form>

    <!-- 列表切换 -->
    <el-tabs v-model="activeTab" @tab-click="handleTabChange">
      <!-- 奖品记录 -->
      <el-tab-pane name="prize">
        <span slot="label">奖品记录</span>
        <div class="tab-header">
          <span class="prize-tip">仅展示【已完赛】用户的奖品发放/领取情况</span>
          <div>
            <el-button type="primary" size="small" @click="handleExport"
              >导出</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="openImportLogisticsDialog"
              >批量填写物流</el-button
            >
          </div>
        </div>
        <el-table
          ref="prizeTable"
          v-loading="prizeLoading"
          :data="prizeData"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @sort-change="handleSortChange"
        >
          <el-table-column
            type="selection"
            width="65"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="prizeRecordId"
            label="奖品唯一ID"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="uid"
            label="用户ID"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="userNickname"
            label="昵称"
            align="center"
            width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="competitionTitle"
            label="赛事标题"
            align="center"
            min-width="150"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="groupLabel"
            label="组别"
            align="center"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="certificateName"
            label="证书姓名"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="registrationTime"
            label="报名时间"
            align="center"
            width="175"
            sortable="custom"
          >
            <template scope="{ row }">
              <span>{{ formatTime(row.registrationTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="packageName"
            label="套餐名称"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column label="套餐价格" align="center" width="90">
            <template scope="{ row }">
              <span>{{ formatPackagePrice(row.packagePrice) }}元</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="prizeName"
            label="具体奖品名称"
            align="center"
            min-width="130"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="receiverName"
            label="姓名"
            align="center"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="receiverPhone"
            label="手机号"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="fullAddress"
            label="收货地址"
            align="center"
            min-width="160"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="奖品领取" align="center" width="90">
            <template scope="{ row }">
              <span>{{ row.isClaimed === 1 ? "已领取" : "未领取" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="物流状态" align="center" width="90">
            <template scope="{ row }">
              <span>{{
                row.type === 5 ? logisticsStatusText(row.logisticsStatus) : "--"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="logisticsCompany"
            label="物流公司"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="trackingNumber"
            label="物流单号"
            align="center"
            width="140"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="deliveryDeadline"
            label="发货截止时间"
            align="center"
            width="175"
            sortable="custom"
          >
            <template scope="{ row }">
              <span>{{ formatTime(row.deliveryDeadline) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="operationTime"
            label="操作时间"
            align="center"
            width="175"
            sortable="custom"
          >
            <template scope="{ row }">
              <span>{{ formatTime(row.operationTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="100"
          >
            <template scope="{ row }">
              <template v-if="row.type === 5">
                <el-button
                  v-if="row.completionStatus === 1 && row.logisticsStatus === 0"
                  type="text"
                  @click="openLogisticsDialog(row, false)"
                  >填写物流</el-button
                >
                <el-button
                  v-else-if="row.logisticsStatus === 1"
                  type="text"
                  @click="openLogisticsDialog(row, true)"
                  >修改物流</el-button
                >
                <span v-else>-</span>
              </template>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <!-- 报名记录 -->
      <el-tab-pane name="signup">
        <span slot="label">报名记录</span>
        <div class="signup-subtabs-bar">
          <el-tabs
            v-model="signUpSubTab"
            type="card"
            class="signup-subtabs"
            @tab-click="handleSignUpSubTabChange"
          >
            <el-tab-pane label="全部" name="all"></el-tab-pane>
            <el-tab-pane label="已完赛" name="finished"></el-tab-pane>
            <el-tab-pane label="未完赛" name="unfinished"></el-tab-pane>
          </el-tabs>
          <el-button
            type="primary"
            size="small"
            class="signup-export-btn"
            @click="handleSignUpExport"
            >导出</el-button
          >
        </div>
        <el-table
          v-loading="signUpLoading"
          :data="signUpData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="uid"
            label="用户ID"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="userNickname"
            label="用户名称"
            align="center"
            width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="competitionTitle"
            label="赛事标题"
            align="center"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="groupLabel"
            label="报名组别"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="certificateName"
            label="证书姓名"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column label="报名时间" align="center" width="160">
            <template scope="{ row }">
              <span>{{ formatTime(row.registrationTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="packageName"
            label="套餐名称"
            align="center"
            width="120"
          ></el-table-column>
          <el-table-column label="套餐价格" align="center" width="90">
            <template scope="{ row }">
              <span>{{ formatPackagePrice(row.packagePrice) }}元</span>
            </template>
          </el-table-column>
          <el-table-column label="完赛状态" align="center" width="90">
            <template scope="{ row }">
              <span
                :style="{
                  color: row.completionStatus === 1 ? '#67c23a' : '#e6a23c',
                }"
              >
                {{ row.completionStatus === 1 ? "已完赛" : "未完赛" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="完赛公里数"
            prop="completeDistance"
            align="center"
            width="90"
          >
            <template scope="{ row }">
              <span v-if="+row.completeDistance">{{
                +row.completeDistance / 1000
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="160"
          >
            <template scope="{ row }">
              <el-button type="text" @click="viewMatchDetail(row)"
                >查看赛事</el-button
              >
              <el-button type="text" @click="viewPrizeRecord(row)"
                >查看奖品</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <el-pagination
      :current-page.sync="queryForm.pageNum"
      :page-size="queryForm.pageSize"
      layout="prev, pager, next, jumper"
      :total="tableTotal"
      @current-change="handleCurrentChange"
    ></el-pagination>

    <!-- 填写/修改物流弹窗 -->
    <el-dialog
      :title="isEditLogistics ? '修改物流' : '填写物流'"
      v-model="logisticsDialogVisible"
      size="small"
      :modal-append-to-body="false"
      :close-on-click-modal="true"
    >
      <el-form :model="logisticsForm" label-width="90px">
        <el-form-item label="物流公司">
          <el-input
            v-model="logisticsForm.company"
            placeholder="请输入，非必填"
          ></el-input>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input
            v-model="logisticsForm.trackingNo"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <p class="logistics-tip">
        确定后，将通过APPpush/站内信通知用户奖品已发出
      </p>
      <div slot="footer">
        <el-button @click="logisticsDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="logisticsSubmitting"
          @click="confirmLogistics"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 批量导入物流弹窗 -->
    <el-dialog
      title="批量填写物流"
      v-model="importLogisticsDialogVisible"
      size="small"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <div v-if="!importResult">
        <p class="logistics-tip" style="margin-bottom: 16px">
          请上传包含物流信息的 Excel/CSV 文件
        </p>
        <el-upload
          ref="importUpload"
          action=""
          :auto-upload="false"
          :limit="1"
          :on-change="handleImportFileChange"
          :on-remove="handleImportFileRemove"
          accept=".xlsx,.xls,.csv"
        >
          <el-button size="small" type="primary">选择文件</el-button>
          <span slot="tip" class="el-upload__tip"
            >&nbsp;支持 xlsx / xls / csv 格式</span
          >
        </el-upload>
      </div>
      <div v-else class="import-result">
        <p>
          <span class="result-success"
            >成功：{{ importResult.successCount }} 条</span
          >
        </p>
        <p>
          <span class="result-skip">跳过：{{ importResult.skipCount }} 条</span>
        </p>
        <p>
          <span class="result-fail">失败：{{ importResult.failCount }} 条</span>
        </p>
        <div v-if="importResult.messages && importResult.messages.length">
          <p class="result-messages-title">详情：</p>
          <ul class="result-messages">
            <li v-for="(msg, idx) in importResult.messages" :key="idx">
              {{ msg }}
            </li>
          </ul>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="closeImportDialog">{{
          importResult ? "关闭" : "取消"
        }}</el-button>
        <el-button
          v-if="!importResult"
          type="primary"
          :loading="importing"
          @click="confirmImportLogistics"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
const LOG_TAG = "[signUpManage]";

export default {
  name: "signUpManage",
  data() {
    return {
      activeTab: "prize",
      signUpSubTab: "all",
      queryForm: {
        userId: "",
        competitionId: null,
        nickname: "",
        matchName: "",
        prizeName: "",
        logisticsStatus: "",
        pageNum: 1,
        pageSize: 10,
      },
      prizeData: [],
      prizeLoading: false,
      signUpData: [],
      signUpLoading: false,
      tableTotal: 0,
      selectedPrizeIds: [],
      _restoringSelection: false,
      prizeSort: { field: null, asc: true },
      logisticsDialogVisible: false,
      logisticsSubmitting: false,
      isEditLogistics: false,
      logisticsForm: {
        company: "",
        trackingNo: "",
      },
      currentLogisticsRow: null,
      importLogisticsDialogVisible: false,
      importing: false,
      importFile: null,
      importResult: null,
    };
  },
  mounted() {
    const { tab, matchId } = this.$route.query;
    if (tab === "signup") {
      this.activeTab = "signup";
    } else if (tab === "prize") {
      this.activeTab = "prize";
    }
    if (matchId) {
      this.queryForm.competitionId = Number(matchId);
    }
    this.handleQuery();
  },
  methods: {
    isApiSuccess(errorCode) {
      return errorCode === 10000;
    },
    formatTime(ts) {
      if (!ts) return "";
      const d = new Date(ts);
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    /** 后台套餐价格为分，展示为元 */
    formatPackagePrice(priceInCents) {
      if (priceInCents == null || priceInCents === "") return "0";
      const yuan = Number(priceInCents) / 100;
      if (Number.isNaN(yuan)) return "0";
      return yuan % 1 === 0 ? String(yuan) : yuan.toFixed(2);
    },
    logisticsStatusText(status) {
      const map = { 0: "未发货", 1: "已发货", 2: "已签收" };
      return map[status] !== undefined ? map[status] : "未知";
    },
    buildPrizeQuery() {
      const q = this.queryForm;
      const payload = { pageNum: q.pageNum, pageSize: q.pageSize };
      const uid = (q.userId || "").trim();
      if (uid && /^\d+$/.test(uid)) payload.uid = Number(uid);
      const competitionId = String(q.competitionId || "").trim();
      if (competitionId && /^\d+$/.test(competitionId))
        payload.competitionId = Number(competitionId);
      const nickname = (q.nickname || "").trim();
      if (nickname) payload.userNicknameKeyword = nickname;
      const matchName = (q.matchName || "").trim();
      if (matchName) payload.competitionTitleKeyword = matchName;
      const prizeName = (q.prizeName || "").trim();
      if (prizeName) payload.prizeNameKeyword = prizeName;
      if (
        q.logisticsStatus !== "" &&
        q.logisticsStatus !== null &&
        q.logisticsStatus !== undefined
      ) {
        payload.logisticsStatus = q.logisticsStatus;
      }
      if (this.prizeSort.field !== null) {
        payload.sortField = this.prizeSort.field;
        payload.sortAsc = this.prizeSort.asc;
      }
      return payload;
    },
    buildSignUpQuery() {
      const q = this.queryForm;
      const payload = { pageNum: q.pageNum, pageSize: q.pageSize };
      const uid = (q.userId || "").trim();
      if (uid && /^\d+$/.test(uid)) payload.uid = Number(uid);
      const competitionId = String(q.competitionId || "").trim();
      if (competitionId && /^\d+$/.test(competitionId))
        payload.competitionId = Number(competitionId);
      const nickname = (q.nickname || "").trim();
      if (nickname) payload.userNicknameKeyword = nickname;
      const matchName = (q.matchName || "").trim();
      if (matchName) payload.competitionTitleKeyword = matchName;
      if (this.signUpSubTab === "finished") payload.completionStatus = 1;
      else if (this.signUpSubTab === "unfinished") payload.completionStatus = 0;
      return payload;
    },
    handleTabChange() {
      this.queryForm.pageNum = 1;
      this.fetchList();
    },
    handleSignUpSubTabChange() {
      this.queryForm.pageNum = 1;
      this.fetchSignUpList();
    },
    handleQuery() {
      this.queryForm.pageNum = 1;
      this.selectedPrizeIds = [];
      this.fetchList();
    },
    fetchList() {
      if (this.activeTab === "prize") {
        this.fetchPrizeList();
      } else {
        this.fetchSignUpList();
      }
    },
    fetchPrizeList() {
      this.prizeLoading = true;
      this.$http({
        url:
          this.$util.domain + "/adminapi/competition/prize/record/v70310/list",
        method: "POST",
        body: JSON.stringify(this.buildPrizeQuery()),
      })
        .then((res) => {
          const body = res.body || {};
          if (this.isApiSuccess(body.error)) {
            const data = body.data || {};
            this._restoringSelection = true;
            this.prizeData = data.list || [];
            this.tableTotal = data.total || 0;
            this.restorePrizeSelection();
          } else {
            console.warn(LOG_TAG, "fetchPrizeList fail", body);
            this.$util.errorMsg(body.message || "查询失败");
            this.prizeData = [];
            this.tableTotal = 0;
          }
        })
        .catch((err) => {
          console.warn(LOG_TAG, "fetchPrizeList error", err);
          this.prizeData = [];
          this.tableTotal = 0;
        })
        .finally(() => {
          this.prizeLoading = false;
        });
    },
    fetchSignUpList() {
      this.signUpLoading = true;
      this.$http({
        url:
          this.$util.domain + "/adminapi/competition/registration/v70310/list",
        method: "POST",
        body: JSON.stringify(this.buildSignUpQuery()),
      })
        .then((res) => {
          const body = res.body || {};
          if (this.isApiSuccess(body.error)) {
            const data = body.data || {};
            this.signUpData = data.list || [];
            this.tableTotal = data.total || 0;
          } else {
            console.warn(LOG_TAG, "fetchSignUpList fail", body);
            this.$util.errorMsg(body.message || "查询失败");
            this.signUpData = [];
            this.tableTotal = 0;
          }
        })
        .catch((err) => {
          console.warn(LOG_TAG, "fetchSignUpList error", err);
          this.signUpData = [];
          this.tableTotal = 0;
        })
        .finally(() => {
          this.signUpLoading = false;
        });
    },
    resetQuery() {
      this.queryForm = {
        userId: "",
        competitionId: null,
        nickname: "",
        matchName: "",
        prizeName: "",
        logisticsStatus: "",
        pageNum: 1,
        pageSize: 10,
      };
      this.prizeSort = { field: null, asc: true };
      this.selectedPrizeIds = [];
      this.fetchList();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.fetchList();
    },
    handleSelectionChange(selection) {
      if (this._restoringSelection) return;
      const currentPageIds = new Set(
        this.prizeData.map((r) => r.prizeRecordId)
      );
      const selectedOnPage = new Set(selection.map((r) => r.prizeRecordId));
      const kept = this.selectedPrizeIds.filter(
        (id) => !currentPageIds.has(id)
      );
      selectedOnPage.forEach((id) => kept.push(id));
      this.selectedPrizeIds = kept;
    },
    restorePrizeSelection() {
      this.$nextTick(() => {
        const table = this.$refs.prizeTable;
        if (!table) return;
        const selectedSet = new Set(this.selectedPrizeIds);
        this.prizeData.forEach((row) => {
          table.toggleRowSelection(row, selectedSet.has(row.prizeRecordId));
        });
        this.$nextTick(() => {
          this._restoringSelection = false;
        });
      });
    },
    handleSortChange({ prop, order }) {
      const propToField = {
        deliveryDeadline: 1,
        operationTime: 2,
        registrationTime: 3,
      };
      if (!order || !propToField[prop]) {
        this.prizeSort = { field: null, asc: true };
      } else {
        this.prizeSort = {
          field: propToField[prop],
          asc: order === "ascending",
        };
      }
      this.queryForm.pageNum = 1;
      this.fetchPrizeList();
    },
    async handleExport() {
      const payload = Object.assign({}, this.buildPrizeQuery());
      delete payload.pageNum;
      delete payload.pageSize;
      if (this.selectedPrizeIds.length) {
        payload.ids = this.selectedPrizeIds;
      }
      try {
        const res = await fetch(
          this.$util.domain +
            "/adminapi/competition/prize/record/v70310/export",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
            credentials: "include",
          }
        );
        if (!res.ok) throw new Error("export request failed");
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "奖品记录.xlsx";
        a.click();
        URL.revokeObjectURL(url);
        this.$message.success("导出成功");
        this.selectedPrizeIds = [];
        this.$refs.prizeTable && this.$refs.prizeTable.clearSelection();
      } catch (err) {
        console.warn(LOG_TAG, "handleExport error", err);
        this.$util.errorMsg("导出失败");
      }
    },
    async handleSignUpExport() {
      // 复用报名列表筛选条件（含子 tab 的 completionStatus + 顶部搜索条件），导出全量
      const payload = Object.assign({}, this.buildSignUpQuery());
      delete payload.pageNum;
      delete payload.pageSize;
      try {
        const res = await fetch(
          this.$util.domain +
            "/adminapi/competition/registration/v70370/export",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
            credentials: "include",
          }
        );
        if (!res.ok) throw new Error("export request failed");
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "报名记录.xlsx";
        a.click();
        URL.revokeObjectURL(url);
        this.$message.success("导出成功");
      } catch (err) {
        console.warn(LOG_TAG, "handleSignUpExport error", err);
        this.$util.errorMsg("导出失败");
      }
    },
    openLogisticsDialog(row, isEdit = false) {
      this.currentLogisticsRow = row;
      this.isEditLogistics = isEdit;
      this.logisticsForm = {
        company: row.logisticsCompany || "",
        trackingNo: row.trackingNumber || "",
      };
      this.logisticsDialogVisible = true;
    },
    confirmLogistics() {
      if (!this.logisticsForm.trackingNo) {
        this.$message.warning("请输入物流单号");
        return;
      }
      const prizeRecordId =
        this.currentLogisticsRow && this.currentLogisticsRow.prizeRecordId;
      if (!prizeRecordId) return;
      this.logisticsSubmitting = true;
      this.$http({
        url:
          this.$util.domain +
          "/adminapi/competition/prize/record/v70310/fillLogistics",
        method: "POST",
        body: JSON.stringify({
          prizeRecordId,
          logisticsCompany: this.logisticsForm.company || "",
          trackingNumber: this.logisticsForm.trackingNo,
        }),
      })
        .then((res) => {
          const body = res.body || {};
          if (this.isApiSuccess(body.error)) {
            this.$message.success("物流信息填写成功");
            this.logisticsDialogVisible = false;
            this.fetchPrizeList();
          } else {
            console.warn(LOG_TAG, "confirmLogistics fail", body);
            this.$util.errorMsg(
              (body.data && body.data.message) || body.message || "填写失败"
            );
          }
        })
        .catch((err) => {
          console.warn(LOG_TAG, "confirmLogistics error", err);
          this.$util.errorMsg("填写失败");
        })
        .finally(() => {
          this.logisticsSubmitting = false;
        });
    },
    openImportLogisticsDialog() {
      this.importFile = null;
      this.importResult = null;
      this.importLogisticsDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.importUpload) {
          this.$refs.importUpload.clearFiles();
        }
      });
    },
    handleImportFileChange(file) {
      this.importFile = file.raw;
    },
    handleImportFileRemove() {
      this.importFile = null;
    },
    async confirmImportLogistics() {
      if (!this.importFile) {
        this.$message.warning("请选择文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.importFile);
      this.importing = true;
      try {
        const res = await fetch(
          this.$util.domain +
            "/adminapi/competition/prize/record/v70310/importLogistics",
          {
            method: "POST",
            body: formData,
            credentials: "include",
          }
        );
        const body = await res.json();
        if (this.isApiSuccess(body.error)) {
          this.importResult = body.data || {};
          this.fetchPrizeList();
        } else {
          console.warn(LOG_TAG, "confirmImportLogistics fail", body);
          this.$util.errorMsg(body.message || "导入失败");
        }
      } catch (err) {
        console.warn(LOG_TAG, "confirmImportLogistics error", err);
        this.$util.errorMsg("导入失败");
      }
      this.importing = false;
    },
    closeImportDialog() {
      this.importLogisticsDialogVisible = false;
      this.importFile = null;
      this.importResult = null;
    },
    viewMatchDetail(row) {
      this.$router.push({
        path: "/yunying/onlineMatch/matchDetail",
        query: { id: row.competitionId, type: "detail", from: "signUpManage" },
      });
    },
    viewPrizeRecord(row) {
      this.activeTab = "prize";
      this.queryForm.userId = String(row.uid);
      this.queryForm.competitionId = row.competitionId || null;
      this.queryForm.pageNum = 1;
      this.fetchPrizeList();
    },
  },
};
</script>

<style scoped>
.signup-manage {
  padding: 20px;
}
.page-header {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  justify-content: space-between;
  height: 56px;
  margin-bottom: 20px;
  padding: 0 16px;
  background-color: #f5f7fa;
  box-sizing: border-box;
}
.page-header__title {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 18px;
  font-weight: bold;
  line-height: 56px;
  height: 56px;
  overflow: hidden;
}
.search-form {
  margin-bottom: 15px;
}
.tab-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.prize-tip {
  color: #f56c6c;
  font-size: 13px;
}

/* 报名记录子 tabs：缩短高度 + 与右侧导出按钮同行 */
.signup-subtabs-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.signup-subtabs {
  flex: 0 1 auto;
}
.signup-subtabs /deep/ .el-tabs__header {
  margin: 0;
  border-bottom: none;
}
.signup-subtabs /deep/ .el-tabs__item {
  height: 30px;
  line-height: 30px;
  padding: 0 14px;
}
.signup-export-btn {
  flex: 0 0 auto;
  margin-left: 12px;
}
.el-pagination {
  margin-top: 15px;
  text-align: right;
}
.logistics-tip {
  color: #f56c6c;
  font-size: 13px;
  margin-top: 10px;
  padding-left: 10px;
}
.import-result {
  padding: 8px 10px;
  line-height: 1.8;
}
.import-result p {
  margin: 4px 0;
}
.result-success {
  color: #67c23a;
  font-weight: bold;
}
.result-skip {
  color: #e6a23c;
  font-weight: bold;
}
.result-fail {
  color: #f56c6c;
  font-weight: bold;
}
.result-messages-title {
  margin-top: 10px;
  font-weight: bold;
  color: #606266;
}
.result-messages {
  margin: 4px 0 0 16px;
  padding: 0;
  color: #f56c6c;
  font-size: 13px;
}
.result-messages li {
  margin-bottom: 2px;
}
</style>



// WEBPACK FOOTER //
// signUpManage.vue?e2ca7346